import { render } from "./ListOfChannels.vue.js?vue&type=template&id=d0d765de!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ListOfChannels.vue?vue&type=template&id=d0d765de"
import script from "./ListOfChannels.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ListOfChannels.vue?vue&type=script&lang=js"
export * from "./ListOfChannels.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ListOfChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/list-of-channels/ListOfChannels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0d765de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0d765de', __exports__)) {
    api.reload('d0d765de', __exports__)
  }
  
  module.hot.accept("./ListOfChannels.vue.js?vue&type=template&id=d0d765de!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ListOfChannels.vue?vue&type=template&id=d0d765de", () => {
    api.rerender('d0d765de', render)
  })

}


export default __exports__